// extracted by mini-css-extract-plugin
export default {"remove":"SurveyLogicEditor_remove__0OLym","scroll":"SurveyLogicEditor_scroll__qs1eQ"};